import script from "./CreateSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateSection.vue?vue&type=script&lang=ts&setup=true"

import "./CreateSection.vue?vue&type=style&index=0&id=49c262f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c262f8"]])

export default __exports__